import { PracticeEnrollment, SaveOrgCredentialingEnrollmentReq } from 'types/credentialing';

// Status display metadata (roster status = mapped from onboardingStatus)
export const ROSTER_STATUS_META: Record<string, { label: string; bg: string; color: string }> = {
    imported: { label: 'Ready for documents', bg: '#F3F4F6', color: '#6B7280' },
    in_progress: { label: 'In progress', bg: '#DBEAFE', color: '#1D4ED8' },
    complete: { label: 'Complete', bg: '#DCFCE7', color: '#16A34A' },
};

// Business entity choices for the enrollment step. "Other" reveals a free-text
// "Please specify" field.
export const ENTITY_TYPE_OPTIONS: string[] = [
    'Individual / sole proprietor',
    'PLLC',
    'Professional corporation (PC)',
    'Single-member LLC',
    'S Corporation',
    'C Corporation',
    'Other',
];

export const ENTITY_TYPE_OTHER = 'Other';

// The backend stores entity type as a single free string with no "other" companion field, so the
// UI's entityType='Other' + entityTypeOther pair must be collapsed to the real value on save and
// re-derived on load (an entityType not in the preset list is a custom "Other" value).
// NpiRegistryBox 把 NPI 查询态写在表单里（practice 表单与 enrollment 同名空间），
// 这些是纯前端辅助字段，绝不能跟着 enrollment 一起 POST 给后端
export const stripNpiHelpers = <T extends PracticeEnrollment>(enrollment: T): T => {
    const { npiType, npiChecking, npiRegistryName, taxonomyOptions, taxonomy, ...rest } = enrollment;
    return rest as T;
};

export const encodeEnrollmentEntityType = (enrollment: PracticeEnrollment): SaveOrgCredentialingEnrollmentReq => {
    // detail 里的只读字段（payers / onboardingStep）不回传；practice payers 走单独的
    // /group/enrollment/payers，这里也不从 detail 拼 klarityPayerIds，免得旧值盖掉新选择
    const { entityType, entityTypeOther, payers, onboardingStep, ...rest } = stripNpiHelpers(
        enrollment as PracticeEnrollment & { payers?: unknown; onboardingStep?: unknown },
    );
    return {
        ...rest,
        entityType: entityType === ENTITY_TYPE_OTHER ? (entityTypeOther || '').trim() : entityType,
        // 表单 w9FileName 字段绑定 FileUploadPrivate，存的是上传后的文件 url/key，保存时同步作为 w9FileUrl 下发
        w9FileUrl: rest.w9FileName,
    };
};

export const decodeEnrollmentEntityType = (
    entityType?: string,
): Pick<PracticeEnrollment, 'entityType' | 'entityTypeOther'> => {
    const isCustom = !!entityType && !ENTITY_TYPE_OPTIONS.includes(entityType);
    return {
        entityType: isCustom ? ENTITY_TYPE_OTHER : entityType,
        entityTypeOther: isCustom ? entityType : '',
    };
};
